import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import { toast } from "react-hot-toast";
import { BiMap } from "react-icons/bi";
import { FiPhoneCall } from "react-icons/fi";
import { HiOutlineMailOpen } from "react-icons/hi";
import { FaLinkedinIn } from "react-icons/fa";

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_f7mw7hn",
        "template_n7jn8z4",
        form.current,
        "_D0ekNvqJ00vRhTnx"
      )
      .then(
        (result) => {
          console.log(result.text);
          toast.custom((t) => (
            <div
              className={`${
                t.visible ? 'animate-enter' : 'animate-leave'
              } max-w-md w-full bg-white rounded-lg pointer-events-auto flex ring-1 ring-black ring-opacity-5 border-2 border-black`}
            >
              <div className="flex-1 w-0 p-4">
                <div className="flex items-start">
                  <div className="flex-shrink-0 pt-0.5">
                    <img
                      className="h-10 w-10 rounded-full"
                      src="https://i.ibb.co/w6fsbLz/6-DF9672-C-F86-B-472-E-BA6-C-5-A64580-DBD14-removebg-2.png" alt=""
                    />
                  </div>
                  <div className="ml-3 flex-1">
                    <p className="text-sm font-medium text-gray-900">
                      Hi, I got your mail!
                    </p>
                    <p className="mt-1 text-sm text-gray-500">
                        I will get back to you shortly
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex border-l border-gray-200">
                <button
                  onClick={() => toast.dismiss(t.id)}
                  className="w-full border border-transparent rounded-none rounded-r-lg p-4 flex items-center justify-center text-sm font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                >
                  Close
                </button>
              </div>
            </div>
          ))
          
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div className="pb-20 mt-24 lg:mt-36" id="contact">
      <h1 className="text-5xl lg:text-6xl font-bold text-center mb-8 lg:mb-16">Contact Me</h1>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <div className="card mx-auto flex-shrink-0 w-full max-w-lg border-2 border-black bg-base-100">
        <div className="card-body">
          <form ref={form} onSubmit={sendEmail}>
            <div className="form-control">
              <input
                type="text"
                placeholder="Full Name"
                name="user_name"
                className="input input-bordered border-black border-2 w-full max-w-lg  mb-4"
              />
            </div>
            <div className="form-control">
              <input
                type="email"
                placeholder="Email"
                name="user_email"
                className="input input-bordered border-black border-2 w-full max-w-lg mb-4"
              />
            </div>
            <div className="form-control">
              <textarea
                className="textarea border-black border-2 max-w-lg extarea-bordered mb-4"
                name="message"
                placeholder="Your message"
              ></textarea>
            </div>
            <div className="form-control">
              <input className="btn border-2 bg-neon text-black hover:text-white" type="submit" value="Send" />
            </div>
          </form>
        </div>
      </div>
      <div className="mt-10 lg:mt-0">
        <h1 className="text-3xl font-bold mb-4 text-center lg:text-left">Let's get in touch.</h1>
        <h2 className="mb-8 text-center lg:text-left">I'm currently specializing in Front-end Development. Feel free to get in touch and talk more about your projects.</h2>
        <ul className="space-y-4 border-2 border-black p-10 rounded-xl">
          <li className="text-sm">
            <BiMap className="inline  mr-4 text-xl lg:text-3xl"/>33 No. Bayezid Bostami R/A, Chittagong, Bangladesh
          </li>
          <li className="text-sm">
            <FiPhoneCall className="inline mr-4 text-xl lg:text-2xl"/>+88 018 6611 3132
          </li>
          <li className="text-sm">
            <HiOutlineMailOpen className="inline mr-4 text-xl lg:text-3xl"/>mahifarhat@gmail.com
          </li>
          <li className="text-sm">
            <FaLinkedinIn className="inline ml-1 mr-4 text-xl lg:text-2xl"/>https://www.linkedin.com/in/farhatmahi/
          </li >
        </ul>
      </div>
      </div>
    </div>
  );
};

export default Contact;
